import type { NewActivity, NewRoute } from '@cobliteam/api-lib';

export const activityTimeCheck = (
  route: NewRoute,
  activity?: NewActivity,
  nextActivity?: NewActivity
) =>
  route.break &&
  activity &&
  nextActivity &&
  activity.startTime &&
  nextActivity.startTime &&
  route.break.startTime >= activity.startTime &&
  route.break.endTime <= nextActivity.startTime
    ? route.break
    : undefined;
